import React from "react";
import {
  AccessTime,
  CheckCircleOutline,
  DateRange,
  Foundation,
  Groups,
  ModeStandby,
  Policy,
  TransferWithinAStation,
  Workspaces,
  WorkspacesOutlined,
} from "@mui/icons-material";

export const departmentWiseHeader = [
  {
    name: "Date",
    key: "date",
  },
  {
    name: "Department",
    key: "department_name",
  },
  {
    name: "Shift Name",
    key: "shift_name",
  },
  {
    name: "Total Assigned",
    key: "total_assigned",
  },
  {
    name: "Present",
    key: "present",
  },
  {
    name: "Missing",
    key: "missing",
  },
  {
    name: "Leave",
    key: "leave",
  },
  {
    name: "Absent",
    key: "absent",
  },
  {
    name: "Over Time",
    key: "overtime",
  },
  {
    name: "Early Exit",
    key: "early_exit",
  },
  {
    name: "Late Entry",
    key: "late_entry",
  },
];

export const departmentExpandHeader = [
  {
    name: "Shift Name",
    key: "shift_name",
  },
  {
    name: "Total Assigned",
    key: "assigned_count",
  },
  {
    name: "Present",
    key: "present_count",
  },
  {
    name: "Missing",
    key: "missing_count",
  },
  {
    name: "Leave",
    key: "leave_count",
  },
  {
    name: "Absent",
    key: "absent_count",
  },
  {
    name: "Over Time",
    key: "overtime_count",
  },
  {
    name: "Early Exit",
    key: "early_exit_count",
  },
  {
    name: "Late Entry",
    key: "late_entry_count",
  },
];

export const shiftCategoryWise = [
  {
    name: "Date",
    key: "date",
  },
  {
    name: "Shift Name",
    key: "shift_name",
  },
  {
    name: "Department",
    key: "department_name",
  },

  {
    name: "Total Assigned",
    key: "total_assigned",
  },
  {
    name: "Present",
    key: "present",
  },
  {
    name: "Missing",
    key: "missing",
  },
  {
    name: "Leave",
    key: "leave",
  },
  {
    name: "Absent",
    key: "absent",
  },
  {
    name: "Over Time",
    key: "overtime",
  },
  {
    name: "Early Exit",
    key: "early_exit",
  },
  {
    name: "Late Entry",
    key: "late_entry",
  },
];

export const shiftWiseExpandDetails = [
  {
    name: "Department Name",
    key: "department_name",
  },
  {
    name: "Total Assigned",
    key: "assigned_count",
  },
  {
    name: "Present",
    key: "present_count",
  },
  {
    name: "Missing",
    key: "missing_count",
  },
  {
    name: "Leave",
    key: "leave_count",
  },
  {
    name: "Absent",
    key: "absent_count",
  },
  {
    name: "Over Time",
    key: "overtime_count",
  },
  {
    name: "Early Exit",
    key: "early_exit_count",
  },
  {
    name: "Late Entry",
    key: "late_entry_count",
  },
];

export const workUnitWise = [
  {
    name: "Date",
    key: "date",
  },
  {
    name: "Shift Name",
    key: "shift_name",
  },
  {
    name: "Department",
    key: "department",
  },
  {
    name: "Unit Name",
    key: "department",
  },
  {
    name: "Total Number of work units",
    key: "total_assigned",
  },
  {
    name: "Assigned Default Unit",
    key: "present",
  },
  {
    name: "Assigned Additional Unit",
    key: "missing",
  },
  {
    name: "Total Assigned Unit",
    key: "leave",
  },
  {
    name: "Unassigned",
    key: "absent",
  },
];

export const workUnitWiseDetails = [
  {
    name: "Shift Name",
    key: "shift_name",
  },
  {
    name: "Department",
    key: "department",
  },
  {
    name: "Unit Name",
    key: "department",
  },
  {
    name: "Total Number of work units",
    key: "total_assigned",
  },
  {
    name: "Assigned Default Unit",
    key: "present",
  },
  {
    name: "Assigned Additional Unit",
    key: "missing",
  },
  {
    name: "Total Assigned Unit",
    key: "leave",
  },
  {
    name: "Unassigned",
    key: "absent",
  },
];
//Leave Summary
export const leaveSummaryListView = [
  {
    name: "Name",
    key: "user_name",
  },
  {
    name: "Department",
    key: "department",
  },
  {
    name: "Annual Allowance",
    key: "annual_allowance",
  },
  {
    name: "Total Credited",
    key: "credited_leave",
  },
  {
    name: "Planned",
    key: "planned_leave",
  },
  {
    name: "Used",
    key: "used_leave",
  },
  {
    name: "Expired",
    key: "expired_leave",
  },
  {
    name: "Balance",
    key: "available_leave",
  },
  {
    name: "Permissions",
    key: "permission_count",
  },
  {
    name: "Action",
    key: "",
  },
];
//Attendance List view Headers

export const attendanceHeaderList = [
  {
    name: "",
    key: "",
  },
  {
    name: "Name",
    key: "user_name",
  },
  {
    name: "Shift",
    key: "shift_name",
  },
  {
    name: "Check-In",
    key: "check_in_time_formatted",
  },
  {
    name: "Check-Out",
    key: "check_out_time_formatted",
  },
  {
    name: "Breaks",
    key: "planned_leave",
  },
  {
    name: "Shift Hours",
    key: "used_leave",
  },
  {
    name: "Over Time Hours",
    key: "expired_leave",
  },
  {
    name: "Unit",
    key: "available_leave",
  },
  {
    name: "Total Working hours",
    key: "permission_count",
  },
  {
    name: "Leave Credit Hours",
    key: "",
  },
  {
    name: "Status",
    key: "",
  },
];

export const weekOffType = [
  {
    id: 1,
    label: "Weekly",
  },
  {
    id: 2,
    label: "On Duty",
  },
  {
    id: 2,
    label: "Field Duty",
  },
];

export const overTimeKeyPair = [
  {
    key: "checkbox",
    name: "",
  },
  {
    key: "date",
    name: "Date",
  },
  {
    key: "user_name",
    name: "Employee name",
  },
  {
    key: "shift_name",
    name: "Shift Name",
  },
  {
    key: "work_hours",
    name: "Working Hours",
  },
  {
    key: "total_shift_time",
    name: "Shift Time",
  },
  {
    key: "overtime_start_formated",
    name: "OverTime Start",
  },
  {
    key: "overtime_end_formated",
    name: "OverTime End",
  },

  {
    key: "overtime",
    name: "Over Time",
  },

  {
    key: "action",
    name: "Action",
  },
];

export const workAuthorizationPending = [
  {
    key: "checkbox",
    name: "",
  },
  {
    key: "employee_name",
    name: "Name",
  },
  {
    key: "ot_date",
    name: "Date",
  },
  {
    key: "ot_duration",
    name: "Duration",
  },
  {
    key: "ot_consideration",
    name: "Consideration",
  },
  {
    key: "Action",
    name: "Action",
  },
];

export const workAuthorizationHistory = [
  {
    key: "employee_name",
    name: "Name",
  },
  {
    key: "ot_date",
    name: "Date",
  },
  {
    key: "ot_duration",
    name: "Duration",
  },
  {
    key: "ot_consideration",
    name: "Consideration",
  },
  {
    key: "status",
    name: "Status",
  },
];

export const otPayrollPendingHistory = [
  {
    key: "checkbox",
    name: "",
  },
  {
    key: "user_name",
    name: "Name",
  },
  {
    key: "date",
    name: "Date",
  },
  {
    key: "overtime_start_formated",
    name: "OT Start",
  },
  {
    key: "overtime_end_formated",
    name: "OT End",
  },
  {
    key: "overtime_break_duration",
    name: "Break Duration",
  },
  {
    key: "overtime_duration",
    name: "Duration",
  },
  {
    key: "ot_consideration",
    name: "Consideration",
  },
  {
    key: "status",
    name: "Status",
  },
  {
    key: "Action",
    name: "Action",
  },
];

export const overtimePendingHistory = [
  {
    key: "checkbox",
    name: "",
  },
  {
    key: "user_name",
    name: "Name",
  },
  {
    key: "date",
    name: "Date",
  },
  {
    key: "overtime_start_formated",
    name: "OT Start",
  },
  {
    key: "overtime_end_formated",
    name: "OT End",
  },
  {
    key: "overtime_break_duration",
    name: "Break Hours",
  },
  {
    key: "overtime_duration",
    name: "Worked Hours",
  },
  {
    key: "pre_approved_duration",
    name: "Authorized Hours",
  },
  {
    key: "final_approved_duration",
    name: "Approved Hours",
  },
  {
    key: "status",
    name: "Status",
  },
  {
    key: "Action",
    name: "Action",
  },
];

export const entryMethod = [
  {
    label: "IN",
  },
  {
    label: "OUT",
  },
];

export const lateReportHeader = [
  {
    key: "username",
    name: "Employee Name",
  },
  {
    key: "employee_id",
    name: "Employee Id",
  },
  {
    key: "date",
    name: "Date",
  },
  {
    key: "department",
    name: "Department",
  },
  {
    key: "shift_name",
    name: "Shift Name",
  },
  {
    key: "shift_start_time",
    name: "Shift Start Time",
  },
  {
    key: "shift_max_start_time",
    name: "Shift Max Start Time",
  },
  {
    key: "shift_end_time",
    name: "Shift End Time",
  },
  {
    key: "shift_max_end_time",
    name: "Shift Max End Time",
  },
  {
    key: "check_in_time",
    name: "CheckIn Time",
  },
  {
    key: "check_out_time",
    name: "CheckOut Time",
  },
  {
    key: "actual_duration",
    name: "Late Arrival Duration",
  },
];

export const leaveReportKeyAndHeader = [
  {
    key: "employee_id",
    name: "Employee Id",
  },
  {
    key: "username",
    name: "Employee Name",
  },
  {
    key: "department_name",
    name: "Department",
  },
  {
    key: "paid_leave_count",
    name: "Paid Leave",
  },
  {
    key: "unpaid_leave_count",
    name: "Unpaid Leave",
  },
  {
    key: "absent_count",
    name: "Absent",
  },
  {
    key: "permission_count",
    name: "Permission",
  },
  {
    key: "missing_count",
    name: "Missing",
  },
  {
    key: "late_early_count",
    name: "Late/Early",
  },
];

// ot updated design

export const OTPreApprovalHeader = [
  {
    key: "expand",
    name: "",
  },
  {
    key: "employee_name",
    name: "Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "ot_date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "ot_date",
      toField: "ot_date",
    },
  },
  {
    key: "ot_duration",
    name: "Duration",
    type: "time",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    key: "ot_consideration",
    name: "Applicable Timing",
    type: "autocomplete",
    icon: <Groups fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <ModeStandby fontSize="small" />,
  },
];

export const OTPostApprovalHeader = [
  {
    key: "expand",
    name: "",
  },
  {
    key: "employee_name",
    name: "Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    key: "worked_hours",
    name: "Worked Hrs",
    type: "time",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    key: "basis",
    name: "Basis",
    type: "autocomplete",
    icon: <Foundation fontSize="small" />,
  },
  {
    key: "worked_qty",
    name: "Worked Qty",
    type: "string",
    icon: <WorkspacesOutlined fontSize="small" />,
  },
  {
    key: "approved_qty",
    name: "Approved Qty",
    type: "string",
    icon: <CheckCircleOutline fontSize="small" />,
  },
  {
    key: "payout_policy",
    name: "Payout Policy",
    type: "autocomplete",
    icon: <Policy fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

export const otTimingOptions = [
  {
    id: "Only Before",
    label: "Before shift",
    description:
      "Allow employees to log overtime for hours worked before their scheduled shift begins.",
  },
  {
    id: "Only After",
    label: "After shift",
    description:
      "Enable overtime entry for additional hours worked beyond the regular shift end time.",
  },
  {
    id: "Before and After",
    label: "Before and After Shift",
    description:
      "Permit overtime logging for both early start and extended work hours outside the regular shift schedule.",
  },
];
